/**
 * Search Users Action
 */

import {
  ACTION_GET_USERS,
  ACTION_GET_USERS_WITH_RESET_SUCCESS,
  ACTION_GET_USERS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export type SearchParams = {
  name: string;
  limit?: number;
};

export function search(params: SearchParams) {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_GET_USERS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: 'users/search',
        method: 'get',
        data: params,
        success: (response: any) => {
          dispatch({ type: ACTION_GET_USERS_WITH_RESET_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_USERS_FAILURE, payload: error });
        },
      },
    });
  };
}
